import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  mainFaqList = [
    {
      question: this.translate.instant('faqs.question_1'),
      answer: this.translate.instant('faqs.answer_1')
    },
    // {
    //   question: this.translate.instant('faqs.question_2'),
    //   answer: this.translate.instant('faqs.answer_2')
    // },
    {
      question: this.translate.instant('faqs.question_3'),
      answer: this.translate.instant('faqs.answer_3')
    },
    {
      question: this.translate.instant('faqs.question_4'),
      answer: this.translate.instant('faqs.answer_4')
    },
    {
      question: this.translate.instant('faqs.question_5'),
      answer: this.translate.instant('faqs.answer_5')
    },
    {
      question: this.translate.instant('faqs.question_6'),
      answer: this.translate.instant('faqs.answer_6')
    },
  ];
  faqList = [];
  activeIndex = 0;

  marketPlaceFaqList = [
    {
      question: this.translate.instant('faqs.mp_question_1'),
      answer: this.translate.instant('faqs.mp_answer_1')
    },
    {
      question: this.translate.instant('faqs.mp_question_2'),
      answer: this.translate.instant('faqs.mp_answer_2')
    },
    {
      question: this.translate.instant('faqs.mp_question_3'),
      answer: this.translate.instant('faqs.mp_answer_3')
    },
    {
      question: this.translate.instant('faqs.mp_question_4'),
      answer: this.translate.instant('faqs.mp_answer_4')
    },
    {
      question: this.translate.instant('faqs.mp_question_5'),
      answer: this.translate.instant('faqs.mp_answer_5')
    },
    {
      question: this.translate.instant('faqs.mp_question_6'),
      answer: this.translate.instant('faqs.mp_answer_6')
    },
    {
      question: this.translate.instant('faqs.mp_question_7'),
      answer: this.translate.instant('faqs.mp_answer_7')
    },
    {
      question: this.translate.instant('faqs.mp_question_8'),
      answer: this.translate.instant('faqs.mp_answer_8')
    },
    {
      question: this.translate.instant('faqs.mp_question_9'),
      answer: this.translate.instant('faqs.mp_answer_9')
    },
    {
      question: this.translate.instant('faqs.mp_question_10'),
      answer: this.translate.instant('faqs.mp_answer_10')
    },
  ];
  marketPlacefaqList = [];
  marketPlaceActiveIndex = -1;

  friendsFaqList = [
    {
      question: this.translate.instant('faqs.fd_question_1'),
      answer: this.translate.instant('faqs.fd_answer_1')
    },
    {
      question: this.translate.instant('faqs.fd_question_2'),
      answer: this.translate.instant('faqs.fd_answer_2')
    },
    {
      question: this.translate.instant('faqs.fd_question_3'),
      answer: this.translate.instant('faqs.fd_answer_3')
    },
    {
      question: this.translate.instant('faqs.fd_question_4'),
      answer: this.translate.instant('faqs.fd_answer_4')
    },
    {
      question: this.translate.instant('faqs.fd_question_5'),
      answer: this.translate.instant('faqs.fd_answer_5')
    }
  ];
  friendsfaqList = [];
  friendsActiveIndex = -1;

  communitiesFaqList = [
    {
      question: this.translate.instant('faqs.cm_question_1'),
      answer: this.translate.instant('faqs.cm_answer_1')
    },
    {
      question: this.translate.instant('faqs.cm_question_2'),
      answer: this.translate.instant('faqs.cm_answer_2')
    },
    {
      question: this.translate.instant('faqs.cm_question_3'),
      answer: this.translate.instant('faqs.cm_answer_3')
    },
    {
      question: this.translate.instant('faqs.cm_question_4'),
      answer: this.translate.instant('faqs.cm_answer_4')
    },
    {
      question: this.translate.instant('faqs.cm_question_5'),
      answer: this.translate.instant('faqs.cm_answer_5')
    },
    {
      question: this.translate.instant('faqs.cm_question_6'),
      answer: this.translate.instant('faqs.cm_answer_6')
    },
    {
      question: this.translate.instant('faqs.cm_question_7'),
      answer: this.translate.instant('faqs.cm_answer_7')
    }
  ];
  communitiesfaqList = [];
  communitiesActiveIndex = -1;

  vinoCoinsFaqList = [
    {
      question: this.translate.instant('faqs.vc_question_1'),
      answer: this.translate.instant('faqs.vc_answer_1')
    },
    {
      question: this.translate.instant('faqs.vc_question_2'),
      answer: this.translate.instant('faqs.vc_answer_2')
    },
    {
      question: this.translate.instant('faqs.vc_question_3'),
      answer: this.translate.instant('faqs.vc_answer_3')
    },
    {
      question: this.translate.instant('faqs.vc_question_4'),
      answer: this.translate.instant('faqs.vc_answer_4')
    },
    {
      question: this.translate.instant('faqs.vc_question_5'),
      answer: this.translate.instant('faqs.vc_answer_5')
    }
  ];
  vinoCoinsfaqList = [];
  vinoCoinsActiveIndex = -1;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((data) => {
      this.mainFaqList = [
        {
          question: this.translate.instant('faqs.question_1'),
          answer: this.translate.instant('faqs.answer_1')
        },
        // {
        //   question: this.translate.instant('faqs.question_2'),
        //   answer: this.translate.instant('faqs.answer_2')
        // },
        {
          question: this.translate.instant('faqs.question_3'),
          answer: this.translate.instant('faqs.answer_3')
        },
        {
          question: this.translate.instant('faqs.question_4'),
          answer: this.translate.instant('faqs.answer_4')
        },
        {
          question: this.translate.instant('faqs.question_5'),
          answer: this.translate.instant('faqs.answer_5')
        },
        {
          question: this.translate.instant('faqs.question_6'),
          answer: this.translate.instant('faqs.answer_6')
        },
      ];
      this.faqList = this.mainFaqList.slice();

      this.marketPlaceFaqList = [
        {
          question: this.translate.instant('faqs.mp_question_1'),
          answer: this.translate.instant('faqs.mp_answer_1')
        },
        {
          question: this.translate.instant('faqs.mp_question_2'),
          answer: this.translate.instant('faqs.mp_answer_2')
        },
        {
          question: this.translate.instant('faqs.mp_question_3'),
          answer: this.translate.instant('faqs.mp_answer_3')
        },
        {
          question: this.translate.instant('faqs.mp_question_4'),
          answer: this.translate.instant('faqs.mp_answer_4')
        },
        {
          question: this.translate.instant('faqs.mp_question_5'),
          answer: this.translate.instant('faqs.mp_answer_5')
        },
        {
          question: this.translate.instant('faqs.mp_question_6'),
          answer: this.translate.instant('faqs.mp_answer_6')
        },
        {
          question: this.translate.instant('faqs.mp_question_7'),
          answer: this.translate.instant('faqs.mp_answer_7')
        },
        {
          question: this.translate.instant('faqs.mp_question_8'),
          answer: this.translate.instant('faqs.mp_answer_8')
        },
        {
          question: this.translate.instant('faqs.mp_question_9'),
          answer: this.translate.instant('faqs.mp_answer_9')
        },
        {
          question: this.translate.instant('faqs.mp_question_10'),
          answer: this.translate.instant('faqs.mp_answer_10')
        },
      ];
      this.marketPlacefaqList = this.marketPlaceFaqList.slice();

      this.friendsFaqList = [
        {
          question: this.translate.instant('faqs.fd_question_1'),
          answer: this.translate.instant('faqs.fd_answer_1')
        },
        {
          question: this.translate.instant('faqs.fd_question_2'),
          answer: this.translate.instant('faqs.fd_answer_2')
        },
        {
          question: this.translate.instant('faqs.fd_question_3'),
          answer: this.translate.instant('faqs.fd_answer_3')
        },
        {
          question: this.translate.instant('faqs.fd_question_4'),
          answer: this.translate.instant('faqs.fd_answer_4')
        },
        {
          question: this.translate.instant('faqs.fd_question_5'),
          answer: this.translate.instant('faqs.fd_answer_5')
        }
      ];
      this.friendsfaqList = this.friendsFaqList.slice();

      this.communitiesFaqList = [
        {
          question: this.translate.instant('faqs.cm_question_1'),
          answer: this.translate.instant('faqs.cm_answer_1')
        },
        {
          question: this.translate.instant('faqs.cm_question_2'),
          answer: this.translate.instant('faqs.cm_answer_2')
        },
        {
          question: this.translate.instant('faqs.cm_question_3'),
          answer: this.translate.instant('faqs.cm_answer_3')
        },
        {
          question: this.translate.instant('faqs.cm_question_4'),
          answer: this.translate.instant('faqs.cm_answer_4')
        },
        {
          question: this.translate.instant('faqs.cm_question_5'),
          answer: this.translate.instant('faqs.cm_answer_5')
        },
        {
          question: this.translate.instant('faqs.cm_question_6'),
          answer: this.translate.instant('faqs.cm_answer_6')
        },
        {
          question: this.translate.instant('faqs.cm_question_7'),
          answer: this.translate.instant('faqs.cm_answer_7')
        }
      ];
      this.communitiesfaqList = this.communitiesFaqList.slice();

      this.vinoCoinsFaqList = [
        {
          question: this.translate.instant('faqs.vc_question_1'),
          answer: this.translate.instant('faqs.vc_answer_1')
        },
        {
          question: this.translate.instant('faqs.vc_question_2'),
          answer: this.translate.instant('faqs.vc_answer_2')
        },
        {
          question: this.translate.instant('faqs.vc_question_3'),
          answer: this.translate.instant('faqs.vc_answer_3')
        },
        {
          question: this.translate.instant('faqs.vc_question_4'),
          answer: this.translate.instant('faqs.vc_answer_4')
        },
        {
          question: this.translate.instant('faqs.vc_question_5'),
          answer: this.translate.instant('faqs.vc_answer_5')
        }
      ];
      this.vinoCoinsfaqList = this.vinoCoinsFaqList.slice();
    });
    this.faqList = this.mainFaqList.slice();
    this.marketPlacefaqList = this.marketPlaceFaqList.slice();
    this.friendsfaqList = this.friendsFaqList.slice();
    this.communitiesfaqList = this.communitiesFaqList.slice();
    this.vinoCoinsfaqList = this.vinoCoinsFaqList.slice();
  }
// changes // 
  toggleAccordion(index: number, type: string) {
    switch (type) {
      case 'default':
        this.activeIndex = this.activeIndex === index ? -1 : index;
        this.marketPlaceActiveIndex = this.friendsActiveIndex = this.communitiesActiveIndex = this.vinoCoinsActiveIndex = -1;
        break;
      case 'marketPlace':
        this.marketPlaceActiveIndex = this.marketPlaceActiveIndex === index ? -1 : index;
        this.activeIndex = this.friendsActiveIndex = this.communitiesActiveIndex = this.vinoCoinsActiveIndex = -1;
        break;
      case 'friends':
        this.friendsActiveIndex = this.friendsActiveIndex === index ? -1 : index;
        this.activeIndex = this.marketPlaceActiveIndex = this.communitiesActiveIndex = this.vinoCoinsActiveIndex = -1;
        break;
      case 'communities':
        this.communitiesActiveIndex = this.communitiesActiveIndex === index ? -1 : index;
        this.activeIndex = this.marketPlaceActiveIndex = this.friendsActiveIndex = this.vinoCoinsActiveIndex = -1;
        break;
      case 'vinoCoins':
        this.vinoCoinsActiveIndex = this.vinoCoinsActiveIndex === index ? -1 : index;
        this.activeIndex = this.marketPlaceActiveIndex = this.friendsActiveIndex = this.communitiesActiveIndex = -1;
        break;
    }
  }

  filterFaqList(event: any): void {
    let searchedText = event.target.value;
    if (searchedText.length) {
      searchedText = searchedText.toLowerCase();
      this.faqList = this.mainFaqList.filter((item: any) => item.question.toLowerCase().includes(searchedText) || item.answer.toLowerCase().includes(searchedText));
      this.marketPlacefaqList = this.marketPlaceFaqList.filter((item: any) => item.question.toLowerCase().includes(searchedText) || item.answer.toLowerCase().includes(searchedText));
      this.friendsfaqList = this.friendsFaqList.filter((item: any) => item.question.toLowerCase().includes(searchedText) || item.answer.toLowerCase().includes(searchedText));
      this.communitiesfaqList = this.communitiesFaqList.filter((item: any) => item.question.toLowerCase().includes(searchedText) || item.answer.toLowerCase().includes(searchedText));
      this.vinoCoinsfaqList = this.vinoCoinsFaqList.filter((item: any) => item.question.toLowerCase().includes(searchedText) || item.answer.toLowerCase().includes(searchedText));
    } else {
      this.faqList = this.mainFaqList.slice();
      this.marketPlacefaqList = this.marketPlaceFaqList.slice();
      this.friendsfaqList = this.friendsFaqList.slice();
      this.communitiesfaqList = this.communitiesFaqList.slice();
      this.vinoCoinsfaqList = this.vinoCoinsFaqList.slice();
    }
  }
}
